<template>

  <tr>
    <td
      class="text-truncate"
      style="padding-top: 4px; padding-bottom: 4px; width: calc(34px + 20px);">
      <Avatar
        :src="value.author_user_url"
        :name="value.author_user_id.name"
        size="34px"
        radius="22px"
        resize="100x100x1" />
    </td>
    <td>{{ value.author_user_id.name }}</td>
    <td><span v-html="value.message"></span></td>
    <td class="text-truncate">{{ $d(new Date(value.created_at), 'long') }}</td>
  </tr>

</template>

<script>
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'Audit',
  components: {
    Avatar
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    entity () {
      return {
        candidate: 'Candidate',
        job: 'Job'
      }[this.value.entity] || this.value.entity
    },
    method () {
      return {
        create: 'Cruou',
        update: 'Atualizou',
        delete: 'Deletou',
        merge: 'Unificou'
      }[this.value.method] || this.value.method
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Audit/AuditItem.vue